import {
  Center,
  Column,
  CustomSpinner,
  EmptyScreen,
  SortingArrow,
  Text,
  TSortValue,
} from '~/commonComponents';
import { CreatePostingButton } from '~/components/PermanentJobsV2/CreatePostingButton';
import { IJobPostEntity, JobPostingSortableField } from '~/domain/PermanentJobs';
import BriefcaseEmptyScreenIcon from '~/images/briefcase-empty-screen-icon.svg';
import { Colors } from '~/themes/colors';
import { JobCard } from '../JobCard';
import { DefaultTableStyles } from './Constants';

interface IDefaultTableProps {
  data: IJobPostEntity[];
  formSorting: TSortValue;
  isLoading: boolean;
  onSortChanges(formSorting: TSortValue): void;
}

export const DefaultTable = ({
  data,
  formSorting,
  isLoading,
  onSortChanges,
}: IDefaultTableProps) => {
  const isEmptyData = data.length === 0;

  if (!isLoading && isEmptyData) {
    return (
      <EmptyScreen
        Icon={() => (
          <img
            alt="briefcase-empty-screen-icon"
            src={BriefcaseEmptyScreenIcon}
            height={170}
            width={170}
          />
        )}
        title="No jobs posted yet!"
        description={
          <Column alignItems="center" gap={48}>
            <Text color={Colors.neutral_500}>
              You haven’t posted any jobs yet. Post your first
              <br />
              job to start connecting with qualified dental
              <br />
              professionals in your area!
            </Text>
            <CreatePostingButton />
          </Column>
        }
      />
    );
  }

  return (
    <>
      <table style={DefaultTableStyles.Table}>
        <thead>
          <tr>
            <th style={DefaultTableStyles.TableHeader.JobsCol}>
              <Text bold color={Colors.primary_500} fontSize={18}>
                Jobs
              </Text>
            </th>
            <th style={DefaultTableStyles.TableHeader.HiresCol}>
              <SortingArrow
                sorting={formSorting}
                name={JobPostingSortableField.HireCount}
                variant="primary"
                onChange={onSortChanges}
              >
                <Text bold color={Colors.primary_500} fontSize={18}>
                  Hires
                </Text>
              </SortingArrow>
            </th>
            <th style={DefaultTableStyles.TableHeader.StatusCol}>
              <Text bold color={Colors.primary_500} fontSize={18}>
                Status
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {!isLoading &&
            data.map((it: IJobPostEntity) => (
              <tr key={it.id}>
                <td colSpan={3}>
                  <JobCard {...it} />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {isLoading && (
        <Center marginBlock={32}>
          <CustomSpinner isLoading size={32} />
        </Center>
      )}
    </>
  );
};
